














import { Component, Vue } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import Api from "@/api/shippingSetting/index";

@Component
export default class ShippingSetting extends AbpBase {
  data: any[] = [];
  buttonProps = {
    type: "text",
    size: "small",
  };
  mounted() {
    this.getAddress();
  }
  getAddress() {
    let params = {
      subdistrict: 3,
      // IsDelivery: false,
      SkipCount: 0,
      MaxResultCount: 999,
    };
    Api.addChinaAddress(params).then((res) => {
      this.data = this.setTree(res.data.districts[0].districts);
    });
  }
  setTree(data) {
    return data.map((node) => {
      const item = {
        ...node,
        title: node.name,
        expand: false,
      };
      if (node.level == "province") {
        item.render = (h, { root, node, data }) => {
          return h(
            "span",
            {
              class: "ivu-tree-title",
              style: {
                display: "inline-block",
                width: "98%",
              },
            },
            [
              h("span", [
                h("Icon", {
                  props: {
                    type: "ios-folder-outline",
                  },
                  style: {
                    marginRight: "8px",
                  },
                }),
                h("span", data.title),
              ]),
              h(
                "span",
                {
                  style: {
                    display: "inline-block",
                    float: "right",
                    marginRight: "32px",
                  },
                },
                [
                  h(
                    "Button",
                    {
                      props: Object.assign({}, this.buttonProps, {
                        size: "small",
                        type: "text",
                      }),
                      style: {
                        color: data.isDelivery ? "red" : "#515a6e",
                        marginRight: "50px",
                      },
                      on: {
                        click: () => {
                          this.remove(root, node, data);
                        },
                      },
                    },
                    data.isDelivery ? "启用" : "禁用"
                  ),
                ]
              ),
            ]
          );
        };
      }
      if (node.districts && node.districts.length)
        item.children = this.setTree(node.districts);
      return item;
    });
  }
  renderContent(h, { root, node, data }) {
    return h(
      "span",
      {
        class: "ivu-tree-title",
        style: {
          display: "inline-block",
          width: "98%",
        },
      },
      [
        h("span", [
          h("Icon", {
            props: {
              type: "ios-paper-outline",
            },
            style: {
              marginRight: "8px",
            },
          }),
          h("span", data.title),
        ]),
        h(
          "span",
          {
            style: {
              display: "inline-block",
              float: "right",
              marginRight: data.level == "city" ? "60px" : "32px",
            },
          },
          [
            h(
              "Button",
              {
                props: this.buttonProps,
                style: {
                  color: data.isDelivery ? "red" : "#515a6e",
                },
                on: {
                  click: () => {
                    this.remove(root, node, data);
                  },
                },
              },
              data.isDelivery ? "启用" : "禁用"
            ),
          ]
        ),
      ]
    );
  }
  remove(root, node, data) {
    console.log(root, node, data);
    const target = {
      adcode: data.adcode,
      name: data.name,
      level: data.level,
    };
    Api.updateAddress([target], !data.isDelivery)
      .then((res) => {
        this.$Message.success(data.isDelivery ? "启用成功" : "禁用成功");
        this.getAddress();
      })
      .catch((err) => {
        this.$Message.error("请求失败");
      });
  }
}
